export default "__VITE_ASSET__2fd43b46__"